/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProductsStock200ResponseInner
 */
export interface GetProductsStock200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetProductsStock200ResponseInner
     */
    productId: string;
    /**
     * 
     * @type {number}
     * @memberof GetProductsStock200ResponseInner
     */
    stock: number;
}

/**
 * Check if a given object implements the GetProductsStock200ResponseInner interface.
 */
export function instanceOfGetProductsStock200ResponseInner(value: object): value is GetProductsStock200ResponseInner {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('stock' in value) || value['stock'] === undefined) return false;
    return true;
}

export function GetProductsStock200ResponseInnerFromJSON(json: any): GetProductsStock200ResponseInner {
    return GetProductsStock200ResponseInnerFromJSONTyped(json, false);
}

export function GetProductsStock200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductsStock200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'stock': json['stock'],
    };
}

export function GetProductsStock200ResponseInnerToJSON(json: any): GetProductsStock200ResponseInner {
    return GetProductsStock200ResponseInnerToJSONTyped(json, false);
}

export function GetProductsStock200ResponseInnerToJSONTyped(value?: GetProductsStock200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'stock': value['stock'],
    };
}

